import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=28b0accc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b0accc')) {
      api.createRecord('28b0accc', component.options)
    } else {
      api.reload('28b0accc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=28b0accc&", function () {
      api.rerender('28b0accc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iCve5ibT4ycf/JS/offershelp.vue"
export default component.exports